import "./PrintRichPage.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const enrichData = [
  {
    title: "STORIES",
    items: [
      "Inspiring stories",
      "Jataka tales",
      "Memorable stories",
      "Panchatantra stories",
      "Maharaja Stories",
      "Jungle Stories",
    ],
  },
  {
    title: "PICTORIAL STORIES",
    items: [
      "Moral stories",
      "Tit for tot stories",
      "Lovable stories",
      "Greediness stories",
      "Helping hand stories",
      "Mischievous stories",
    ],
  },
  {
    title: "COMICS",
    items: [
      "Jai hind comics",
      "Historical comics",
      "Mythology comics",
      "Detective comics",
      "Maharaja comics",
      "Biographical comics",
    ],
  },
  {
    title: "WITTY + ANIMAL COMICS",
    items: [
      "Akbar Birbal comics",
      "Maryada Ramanna comics",
      "Tenali ramakrishna comics",
      "Nasiruddin comics",
      "Panchatantra comics",
      "Chaku Dhaku comics",
    ],
  },
  {
    title: "LIFE SKILLS",
    items: [
      "Life lesson stories",
      "Ena mina Dica",
      "Life skill stories",
      "Values stories",
      "Attitude stories",
      "Minute manners",
    ],
  },
  {
    title: "COMIC STRIPS",
    items: [
      "Adi & Alka",
      "Oh my girl",
      "Sticky Sticker",
      "Akbal & Beelbal",
      "Chhota Vikram puzzle story",
      "New age comics",
    ],
  },
];

export default function EnrichPage() {
  return (
    <div className="enrichWrapper" style={{backgroundColor:"pink"}}>
      {enrichData.map((section) => (
        <div className="enrichColumn" key={section.title}>
          <div className="enrichHeading">
            <span className="enrichTitle">{section.title}</span>
          </div>

          <ul className="enrichList">
            {section.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>

          <div className="enrichArrow">
            <KeyboardArrowDownIcon />
          </div>
        </div>
      ))}
    </div>
  );
}